import React, { useEffect, useState } from 'react'
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Link, navigate, useNavigate } from 'react-router-dom';
import { Button, Card, Col, Container, Dropdown, Form, Modal, Nav, Navbar, Row, Spinner, Table } from 'react-bootstrap';
import logo1 from '../Assets/logonew.png'
import "../Admin/AdminMaster/AdminBilling.css";
import './Master.css'
import { Autocomplete, InputLabel, TextField } from '@mui/material';
import { CustomerFindAll, PaymentFirstApi, PaymentInnerTableSave } from '../Admin/API/Api';
import axios from 'axios';
import { toast } from 'react-toastify';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import AdminNavBar from './AdminNavBar';
import NavLogo from './NavLogo';
import { MDBDataTable } from 'mdbreact';

const Payment1 = () => {

  const selectedLanguage = sessionStorage.getItem('selectedLanguage');
    const userdata = JSON.parse(sessionStorage.getItem('userdata'));
    const branchId = userdata.branch_id;
    const Name = userdata ? userdata.branch_name : '';

    const [customer_master, setCustomer_master] = useState([]);
    const [customerId, setCustomerId] = useState('');
    const [loading, setLoading] = useState(false);
    const [selectedCustomerName, setSelectedCustomerName] = useState('');
    const [selectedAmount, setSelectedAmount] = useState('');
    const [selectedBillNo, setSelectedBillNo] = useState('');
    const [show, setShow] = useState(false);
    const [additionalData, setAdditionalData] = useState([]);
    const [amount, setAmount] = useState('');
    const [date, setDate] = useState(dayjs());
    const [month, setMonth] = useState('');

    const handleClose = () => setShow(false);
    const handleShow = (item) => {
      setSelectedCustomerName(item.customer_name);
      setSelectedAmount(item.pay_amount);
      setSelectedBillNo(item.bill_no);
      setMonth(item.monthId)
      setCustomerId(item.customer_id);
      setShow(true);
    }
    const handleCustomerSelect = (customerId) => {
        setCustomerId(customerId);
        fetchAdditionalData(customerId);
    };


    let isPaymentFetched = false
    useEffect(() => {
      if (isPaymentFetched) return
        Customerdata(); 
        isPaymentFetched = true
    }, []);
    

    const Customerdata = () => {
        axios.get(`${CustomerFindAll}/${branchId}`)
            .then((res) => {
                if (res.data !== null) {
                    setCustomer_master(res.data);
                    if (customerId) {
                        fetchAdditionalData(customerId);
                    }
                }
            })
            .catch((err) => {
                console.error("Failed to fetch customer data:", err);
                toast.error("Failed to fetch customer data. Please try again later.");
            });
    };
    
    const fetchAdditionalData = (customerId) => {
        axios.get(`${PaymentFirstApi}/${customerId}/${branchId}`)
            .then((res) => {
                if (res.data === "NOTFOUND") {
                    console.warn("Additional data not found for customer:", customerId);
                    toast.warn("Data not found.");
                } else if(res.data === "ERROR"){
                  toast.warn("Server error");
                }
                else {
                  setAdditionalData(res.data);
              }
    
            })
            .catch((err) => {
                console.error("Failed to fetch additional data:", err);
                toast.error("Failed to fetch additional data. Please try again later.");
            });
    };

    const savedata = () => {
        setLoading(true);
      if (!customerId || !selectedBillNo || !date || !amount || !month) {
        toast.error('Please fill in all fields.');
        return;
    }
      const formattedDate = dayjs(date).format('DD/MM/YYYY');
      const data = {
          customer_id: customerId,
          bill_no: selectedBillNo,
          receive_date: formattedDate,
          receive_amount: amount,
          month: month,
          branch_id: branchId
      };
  
      console.log("data console......", data);
  
      axios.post(PaymentInnerTableSave, data)
          .then((res) => {
          
              if (res.data === "SAVED") {
                console.log("Response:", res.data);
                  toast.success('Data Saved Successfully');
                  handleClose();
                  setDate('');
                  setAmount('');
                  fetchAdditionalData(customerId);
                  setLoading(false);
              } else {
                  toast.error('Failed to save data. Please try again later.');
                  setLoading(false);
              }
          })
          .catch((err) => {
              console.error("Failed to save data:", err);
              toast.error("Failed to save data. Please try again later.");
              setLoading(false);
          });
  };
  



  const data = {
    columns: [
      {
        label: (selectedLanguage === 'Marathi' ? 'अनु.क्र.' : 'Sr.No'),
        field: 'srNo',
        sort: 'asc',
        style: { alignItems: 'center', backgroundColor: 'darkslategray', fontSize: '13px', fontFamily: 'sans-serif' },
        className: 'text-center text-light'
      },
      {
        label: (selectedLanguage === 'Marathi' ? 'महिना' : 'Month'),
        field: 'month',
        sort: 'asc',
        style: { alignItems: 'center', backgroundColor: 'darkslategray', fontSize: '13px', fontFamily: 'sans-serif' },
        className: 'text-center text-light'
      },
      {
        label: (selectedLanguage === 'Marathi' ? 'बिल क्र' : 'Bill No'),
        field: 'billNo',
        sort: 'asc',
        style: { alignItems: 'center', backgroundColor: 'darkslategray', fontSize: '13px', fontFamily: 'sans-serif' },
        className: 'text-center text-light'
      },
      {
        label: (selectedLanguage === 'Marathi' ? 'प्रलंबित. रक्कम' : 'Pen. Amount'),
        field: 'payAmount',
        sort: 'asc',
        style: { alignItems: 'center', backgroundColor: 'darkslategray', fontSize: '13px', fontFamily: 'sans-serif' },
        className: 'text-center text-light'
      },
      {
        label: (selectedLanguage === 'Marathi' ? 'स्थिती' : 'Status'),
        field: 'status',
        sort: 'asc',
        style: { alignItems: 'center', backgroundColor: 'darkslategray', fontSize: '13px', fontFamily: 'sans-serif' },
        className: 'text-center text-light'
      },
      {
        label: '',
        field: 'action',
        sort: 'asc',
        style: { alignItems: 'center', backgroundColor: 'darkslategray', fontSize: '13px', fontFamily: 'sans-serif' },
        className: 'text-center text-light'
      }
    ],
    rows: additionalData
      .filter((item) => item.customer_id === customerId)
      .map((item, index) => ({
        srNo: index + 1,
        month: item.month,
        billNo: item.bill_no,
        payAmount: item.pay_amount,
        status: item.status,
        action: (
          <button className='m-1' style={{ color: "orange", border: "0px", backgroundColor: "transparent" }} onClick={() => handleShow(item)}>
            <i style={{ color: "rgb(255, 93, 0)" }} className="fa-solid fa-plus"></i>
          </button>
        )
      }))
  };

  return (
    <div>
    <AdminNavBar />
       <section className="home-section">
    
       <NavLogo />

    <Row className="m-0 p-0 pt-5 px-md-4 px-2">
        <Col className=' rounded text-center pt-2'
          style={{
            display: "flex",
            justifyContent: "start",
            backgroundColor:"white",
            border:"0px",
            alignItems: "center",
            alignContent:"center",
            color: " rgb(47, 79, 79)",
          }}
        >
          <h5>
           {selectedLanguage === 'Marathi' ? 'पेमेंट' : 'PAYMENT'}
          </h5>
        </Col>
      </Row>

{/* ========================== PAYMENT =========================== */}

<Row className="m-0  py-3 px-2 mx-md-3  rounded">
    <Col className="m-0 p-0 py-3  rounded" style={{background:"white"}} >

        <Row className='m-0 p-0'>
        <Col md={4}>
        <Form.Label><h6 ><b style={{color:"rgb(47, 79, 79)"}}>{selectedLanguage === 'Marathi' ? 'ग्राहक निवडा' : 'Select Customer'}:</b></h6></Form.Label>
        <Autocomplete
                options={customer_master}
                getOptionLabel={(option) => option.customer_name}
                value={customer_master.find((item) => item.customer_id === customerId) || null}
                onChange={(event, newValue) => handleCustomerSelect(newValue ? newValue.customer_id : '')}
                renderInput={(params) => <TextField {...params} size='small' label={selectedLanguage === 'Marathi' ? 'ग्राहक निवडा' : 'Select Customer'} />}
            />
    </Col>
        </Row>
        </Col>
        </Row>

        {/* <Row className="m-0  pt-1 px-2 mx-md-3  rounded">
    <Col className="m-0 p-0  px-3 rounded" style={{background:"white"}} >

        <div style={{ overflowY: 'auto' }}>
            <div style={{ overflowX: 'auto' }}>
              <Table striped bordered hover size="sm" className='shadow mt-3' style={{ textAlign: "center" }}>
                <thead >
                  <tr >
                    <th style={{ alignItems: "center", backgroundColor: "darkslategray", fontSize: "13px", fontFamily: "sans-serif" }} className='text-center text-light'>Sr.No</th>
                    <th style={{ alignItems: "center", backgroundColor: "darkslategray", fontSize: "13px", fontFamily: "sans-serif" }} className='text-center text-light'>Month</th>
                    <th style={{ alignItems: "center", backgroundColor: "darkslategray", fontSize: "13px", fontFamily: "sans-serif" }} className='text-center text-light'>Bill No</th>
                    <th style={{ alignItems: "center", backgroundColor: "darkslategray", fontSize: "13px", fontFamily: "sans-serif" }} className='text-center text-light'>Pay Amount</th>
                    <th style={{ alignItems: "center", backgroundColor: "darkslategray", fontSize: "13px", fontFamily: "sans-serif" }} className='text-center text-light'>Status</th>
                    <th style={{ alignItems: "center", backgroundColor: "darkslategray", fontSize: "13px", fontFamily: "sans-serif" }} className='text-center text-light'></th>
                  </tr>
                </thead>
                 <tbody>
                                        {additionalData
                                          .filter((item) => item.customer_id === customerId) 
                                        .map((item, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{item.month}</td>
                                                <td>{item.bill_no}</td>
                                                <td>{item.pay_amount}</td>
                                                <td>{item.status}</td>
                                                <td>
                                                    <button className='m-1' style={{ color: "orange", border: "0px", backgroundColor: "transparent" }}  onClick={() => handleShow(item)}>
                                                        <i style={{ color: "rgb(255, 93, 0)" }} className="fa-solid fa-plus"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
              </Table>
            </div>
          </div>
          </Col>
        </Row> */}


        <Row className="m-0 p-0 pt-3 px-md-4 px-2 rounded">
      <Col className="m-0 p-0 px-3 py-3 rounded" style={{ background: "white" }}>
        <MDBDataTable
      striped
      bordered
      className='custom-datatable '
      hover
      data={data}
      style={{ textAlign: "center" }}
    />
    </Col>
    </Row>

        {/* ================== Modal ==================== */}

        <Modal className='shadow rounded' show={show} onHide={handleClose}>
          <Modal.Header className='m-0 p-0 ps-3 text-center' style={{ backgroundColor:"rgb(214, 234, 248)", color: "black" }} >
            <Modal.Title >
  
              <p style={{ fontSize: "15px" }} className='text-center mt-2'><b>{selectedLanguage === 'Marathi' ? 'पेमेंट' : 'Payment'}</b></p>
            </Modal.Title>
          </Modal.Header>     

          <Modal.Body>
            <Form encType="multipart/form-data">
            
              <Row className='m-0 p-0'>
                <Col sm={12} md={12} className='mt-3'  style={{display:"flex"}}>
                  <Form.Label><h6 ><b>{selectedLanguage === 'Marathi' ? 'ग्राहकाचे नाव' : 'Customer Name'}:</b>&nbsp; &nbsp;  {selectedCustomerName}</h6></Form.Label>
                </Col>

                <Col sm={12} md={6} className='mt-3 mb-3'>
                  <Form.Label><h6 ><b>{selectedLanguage === 'Marathi' ? 'बिल क्र' : 'Bill No'}:</b></h6></Form.Label>
                  <TextField
                    size="small"
                    style={{ width: '100%' }}
                    type="number"
                    placeholder="Enter Amount"
                    pattern="[0-9]"
                    required
                    readOnly
                    value={selectedBillNo}
                  />
                </Col>

                <Col sm={12} md={6} className='mt-3 mb-3'>
                  <Form.Label><h6 ><b>{selectedLanguage === 'Marathi' ? 'रक्कम' : 'Amount'}:</b></h6></Form.Label>
                  <TextField
                    size="small"
                    style={{ width: '100%' }}
                    type="number"
                    placeholder="Enter Amount"
                    pattern="[0-9]"
                    required
                    readOnly
                    value={selectedAmount}
                  />
                </Col>

                <Col sm={12} md={6} className='mt-2 mb-3'>
              <Form.Label>
                <h6>
                  <b>{selectedLanguage === 'Marathi' ? 'मिळालेली तारीख' : 'Rec. date'}:</b>
                </h6>
              </Form.Label>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
  <DemoContainer components={['DatePicker']}>
    <DatePicker
      format="DD/MM/YYYY"
      label="Select Date"
      value={date}
      onChange={(newDate) => {
        console.log("date res", newDate);
        setDate(newDate);
      }}
      slotProps={{ textField: { size: 'small' } }}
    />
  </DemoContainer>
</LocalizationProvider>
            </Col>

            <Col sm={12} md={6} className='mt-3 mb-3'>
                  <Form.Label><h6 ><b>{selectedLanguage === 'Marathi' ? 'मिळालेली रक्कम' : 'Rec. Amt'}:</b></h6></Form.Label>
                  <TextField
                    size="small"
                    style={{ width: '100%' }}
                    type="number"
                    placeholder="Enter Amount"
                    pattern="[0-9]"
                    required
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                  />
                </Col>

              </Row>

              <Row className='mt-2 mb-3'>
                <Col style={{ display: "flex", justifyContent: "center" }}>
                    <Button
                      style={{
                        border: "0px",
                        backgroundColor: 'rgb(47, 79, 79)',
                        borderRadius: "15px",
                      }}
                      className="py-2 px-3 mx-2 shadow text-light"
                      type="submit"
                      onClick={savedata}
                      disabled={loading}
                    >{loading ? <Spinner animation='border' size='sm' variant="primary" /> : <div>
                     
                      {selectedLanguage === 'Marathi' ? 'जतन करा' : 'Save'}</div>}
                    </Button>
                </Col>
              </Row>
            </Form>


          </Modal.Body>

          <Modal.Footer className='m-0 p-0' style={{ backgroundColor:"rgb(214, 234, 248)",color:"black" }}>
            <Button style={{ color: "black", backgroundColor: "white", border: "2px solid darkslategray", borderRadius: "15px" }} onClick={handleClose}>
              {selectedLanguage === 'Marathi' ? 'रद्द करा' : 'Cancel'}
            </Button>

          </Modal.Footer>
        </Modal>
</section>
        </div>
  )
}

export default Payment1 

